export function splitStoredName(fullName) {
  const parts = String(fullName || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return { first: '', last: '' };
  if (parts.length === 1) return { first: parts[0], last: '' };
  return { first: parts[0], last: parts.slice(1).join(' ') };
}

export function joinNameParts(first, last) {
  return [first, last].map((part) => String(part || '').trim()).filter(Boolean).join(' ');
}

export function formatFullName(first, last) {
  return joinNameParts(first, last) || null;
}

export function formatStoredPersonName(fullName) {
  const joined = String(fullName || '').trim();
  return joined || null;
}

export function formatParentContactLabel(lead) {
  const contact = formatFullName(lead?.parent_first_name, lead?.parent_last_name);
  if (!contact) return null;
  const father = formatStoredPersonName(lead?.father_name);
  const mother = formatStoredPersonName(lead?.mother_name);
  if (father && contact.toLowerCase() === father.toLowerCase()) return `${contact} (Father)`;
  if (mother && contact.toLowerCase() === mother.toLowerCase()) return `${contact} (Mother)`;
  return `${contact} (Guardian)`;
}

export function resolveParentContactNames(form) {
  if (form.contact_person === 'guardian') {
    return {
      parent_first_name: String(form.parent_first_name || '').trim(),
      parent_last_name: String(form.parent_last_name || '').trim(),
    };
  }
  if (form.contact_person === 'father') {
    return {
      parent_first_name: String(form.father_first_name || '').trim(),
      parent_last_name: String(form.father_last_name || '').trim(),
    };
  }
  return {
    parent_first_name: String(form.mother_first_name || '').trim(),
    parent_last_name: String(form.mother_last_name || '').trim(),
  };
}

export function inferContactPerson(preFill) {
  const parentFirst = String(preFill.parent_first_name || '').trim().toLowerCase();
  const parentLast = String(preFill.parent_last_name || '').trim().toLowerCase();
  if (!parentFirst && !parentLast) return '';

  const fatherFirst = String(preFill.father_first_name || splitStoredName(preFill.father_name).first).trim().toLowerCase();
  const fatherLast = String(preFill.father_last_name || splitStoredName(preFill.father_name).last).trim().toLowerCase();
  const motherFirst = String(preFill.mother_first_name || splitStoredName(preFill.mother_name).first).trim().toLowerCase();
  const motherLast = String(preFill.mother_last_name || splitStoredName(preFill.mother_name).last).trim().toLowerCase();

  if (parentFirst === fatherFirst && parentLast === fatherLast) return 'father';
  if (parentFirst === motherFirst && parentLast === motherLast) return 'mother';
  return 'guardian';
}

export function formatSplitNameDisplay(fullName) {
  const { first, last } = splitStoredName(fullName);
  if (!first && !last) return null;
  if (!last) return first;
  return `${first} ${last}`;
}
